import Cookies from 'vue-cookie'

export { default as clone } from 'clone-deep'

const inBrowser = typeof window !== 'undefined'
const Time = inBrowser && window.performance && window.performance.now ? window.performance : Date

const TOKEN_KEY = process.env.VUE_APP_TOKEN_KEY
const APP_TITLE = process.env.VUE_APP_TITLE

export const setToken = token => {
  setCookie(TOKEN_KEY, token)
}

export const getToken = () => {
  const token = getCookie(TOKEN_KEY)
  return token ? token : ''
}

export const getCookie = key => {
  try {
    return JSON.parse(Cookies.get(key))
  } catch (error) {
    // console.log(error)
  }
}

export const setCookie = (key, value, options) => {
  Cookies.set(
    key,
    JSON.stringify(value),
    Object.assign(
      {
        expires: 365
      },
      options
    )
  )
}

export const setTitle = title => {
  window.document.title = getTitle(title)
}

export const getTitle = title => {
  return title && title.length ? formatTitle(title) : APP_TITLE
}

const formatTitle = title => {
  if (!title) return
  // return `${APP_TITLE} - ${title}`
  return title
}

export const addEvent = (name, event) => {
  if ('addEventListener' in document) {
    document.addEventListener(name, event, false)
  }
}

export const saveStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch (domException) {
    if (
      domException.name === 'QuotaExceededError' ||
      domException.name === 'NS_ERROR_DOM_QUOTA_REACHED'
    ) {
      console.log(domException)
    }
  }
}

export const getStorage = key => {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (error) {
    // console.log(error)
  }
}

export function genStateKey() {
  return Time.now().toFixed(3)
}

export function saveWechatRegisterURL() {
  saveStorage('wxurl', { url: window.location.href })
}

export function getWechatRegisterURL() {
  return getStorage('wxurl')
}

export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame =
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      window.msRequestAnimationFrame ||
      function (callback) {
        return window.setTimeout(callback, 1000 / 60)
      }
  }
  const difference = Math.abs(from - to)
  const step = Math.ceil((difference / duration) * 50)

  const scroll = (start, end, step) => {
    if (start === end) {
      endCallback && endCallback()
      return
    }

    let d = start + step > end ? end : start + step
    if (start > end) {
      d = start - step < end ? end : start - step
    }

    if (el === window) {
      window.scrollTo(d, d)
    } else {
      el.scrollTop = d
    }
    window.requestAnimationFrame(() => scroll(d, end, step))
  }
  scroll(from, to, step)
}
